import type { ReactElement } from 'react';

import { useL10n } from '@/l10n/useL10n';
import { BackgroundWrapper } from '@/presentation/widgets/BackgroundWrapper';
import { PrimaryIconButtonRounded } from '@/presentation/widgets/PrimaryIconButton';
import { TabletPasswordPanel } from '@/presentation/widgets/TabletPasswordPanel';

import { useTabletLoginController } from './useTabletLoginController';
import styles from './TabletLoginPage.module.css';

/**
 * Экран пароля планшета: открывается, пока в браузере нет сессии.
 *
 * Выглядит как панель пароля APK (`base_url_page.dart`) — та же
 * [TabletPasswordPanel], что на экране адреса, только без «Подключиться
 * без пароля»: здесь она обошла бы пароль. Вся логика — в
 * [useTabletLoginController].
 */
export function TabletLoginPage(): ReactElement {
  const page = useTabletLoginController();
  const l10n = useL10n();
  return (
    <BackgroundWrapper
      // Та же дверь, что в подвале экрана языка: настройки → PIN → адрес.
      footerActions={[
        <div key="settings" data-testid="tablet-login-settings">
          <PrimaryIconButtonRounded icon="settings" onPressed={page.openSettings} />
        </div>,
      ]}
    >
      <div className={styles.root}>
        <div className={styles.column}>
          {page.tabletTitle !== null && (
            <TabletPasswordPanel
              title={page.tabletTitle}
              // Вход — по PIN, как на экране PIN в APK: только цифры.
              hintText={l10n.enter_pincode}
              inputMode="numeric"
              value={page.password.value}
              onChange={page.handlePinChanged}
              onSubmit={page.submit}
              // Общий киоск: браузер не должен запомнить пароль и
              // подставить его следующему посетителю.
              autoComplete="new-password"
            />
          )}
        </div>
      </div>
    </BackgroundWrapper>
  );
}
